module.exports = "pegasus_template/assets/email1-image-2.png";